import React from 'react';
import { toAbsoluteUrl } from '../../../../../../../_metronic/_helpers';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';

export function IconColumnFormatter(cellContent, row) {
  const getPic = (pic) => {
    if (pic)
      return `${baseUrl}/product-image-download?id=${row.id}&file=${pic}`;
    else return toAbsoluteUrl('/media/logos/logo-gc.png');
  };
  return (
    <div
      style={{ border: '3', width: '50px', height: '50px', borderRadius: '5%' }}
    >
      <img
        className='img-thumbnail'
        style={{ width: '100%', height: '100%' }}
        src={getPic(row.icon)}
      ></img>
    </div>
  );
}
